import { render, staticRenderFns } from "./Criticals.vue?vue&type=template&id=5920736c&"
import script from "./Criticals.js?vue&type=script&lang=js&"
export * from "./Criticals.js?vue&type=script&lang=js&"
import style0 from "../../../../../assets/sass/pages/criticals/criticals.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports